import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { TableColumn } from '../../../dto/util/table-column';
import { TableAction } from '../../../dto/util/table-action';
import { FiltroDto } from '../../../dto/util/filtro-dto';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent implements OnChanges {
  @Output() evento = new EventEmitter<FiltroDto<object>>();
  @Output() eventoAccion = new EventEmitter<object>();
  @Output() selectedItemsChange = new EventEmitter<any[]>();
  @Input() estilosAdicionales: string = '';
  @Input() columnas: TableColumn[] = [];
  @Input() datos: any[] = [];
  @Input() acciones: TableAction[] = [];
  @Input() paginacion = true;
  @Input() totalPaginas = 1;
  @Input() tamano = 10;
  @Input() tamanos = [1, 5, 10, 15, 20];
  @Input() paginaActual = 1;
  @Input() camposOpcionales = false;
  @Input() clickeableRow = false;
  @Input() localFiltering = false;
  @Input() multipleSelection: boolean = false;
  @Input() idColumn: string = 'id';
  @Input() estiloEncabezado: string = '';
  selectedPage = 1;
  isPage = false;
  filtros: any = {};
  campoOrden = '';
  ordenAsc = true;
  datosFiltrados: any[] = [];
  selection = new Set<any>();
  selectedItems: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['columnas']) {
      changes['columnas'].currentValue.forEach((columna: TableColumn) => {
        if (columna.type == 'select') {
          let filtro = this.filtros[columna.fieldFilterElement ?? columna.field];
          if (filtro != undefined && filtro != '' && !columna.elements?.map(element => element[columna.value ?? 'id']).includes(filtro)) {
            this.filtros[columna.fieldFilterElement ?? columna.field] = undefined;
            this.filtrar(this.selectedPage);
          }
        }
      });
    }
    if (this.localFiltering && changes['datos']) {
      //Paginado
      this.totalPaginas = Math.ceil(this.datos.length / this.tamano);
      this.selectedPage = 1;
      this.isPage = !(
        this.selectedPage > this.totalPaginas || this.selectedPage <= 0
      );
      this.datosFiltrados = this.datos.slice(
        (this.selectedPage - 1) * this.tamano,
        this.selectedPage * this.tamano
      );
      //Selects
      for (let i = 0; i < this.columnas.length; i++) {
        if (this.columnas[i].type == 'select') {
          const options: {
            value: string;
            label: string;
          }[] = [];
          this.datos.forEach(x => {
            if (!options.some(y => y.value == x[this.columnas[i].field])) {
              options.push({
                value: x[this.columnas[i].field],
                label: x[this.columnas[i].field],
              });
            }
          });
          this.columnas[i].elements = options;
          this.columnas[i].option = 'label';
          this.columnas[i].value = 'value';
          this.columnas[i].fieldFilterElement = this.columnas[i].field;
        }
      }
    }
  }

  filtrar(page = 1) {
    this.evento.emit({
      filtros: this.filtros,
      pagina: this.paginaActual,
      tamanoPagina: this.tamano,
      ordenarPor: this.campoOrden,
      selectedPage: page,
      ordenarAsc: this.ordenAsc,
    });
    if (this.localFiltering) {
      //Filtrado
      this.datosFiltrados = this.datos.filter(x => {
        return Object.keys(this.filtros).every(key => {
          let column = this.columnas.find(x => x.fieldFilterElement == key);
          if (this.filtros[key] && this.filtros[key] != 'undefined') {
            if (column?.type == 'date') {
              // `filtro` no cambia, ya que siempre debería ser un objeto Date
              const filtro = typeof this.filtros[key] === 'string'
                ? (() => {
                  if (this.filtros[key].includes('-')) {
                    // Formato YYYY-MM-DD
                    return new Date(this.filtros[key]);
                  } else if (this.filtros[key].includes('/')) {
                    // Formato DD/MM/YYYY
                    const [day, month, year] = this.filtros[key].split('/').map(Number);
                    return new Date(year, month - 1, day);
                  } else {
                    throw new Error(`Formato de fecha inválido: ${this.filtros[key]}`);
                  }
                })()
                : this.filtros[key];

              // Convertir `x[key]` a Date solo si es un string
              const fecha =
                typeof x[key] === 'string'
                  ? (() => {
                    if (x[key].includes('-')) {
                      // Formato YYYY-MM-DD
                      return new Date(x[key]);
                    } else if (x[key].includes('/')) {
                      // Formato DD/MM/YYYY
                      const [day, month, year] = x[key].split('/').map(Number);
                      return new Date(year, month - 1, day);
                    } else {
                      throw new Error(`Formato de fecha inválido: ${x[key]}`);
                    }
                  })()
                  : x[key]; // Si ya es un objeto Date, usarlo directamente
              // Comparar las fechas
              return (
                fecha.getUTCDate() === filtro.getUTCDate() &&
                fecha.getUTCMonth() === filtro.getUTCMonth() &&
                fecha.getUTCFullYear() === filtro.getUTCFullYear()
              );
            }
            return x[key]
              ?.toString()
              .toLowerCase()
              .includes(this.filtros[key]?.toString().toLowerCase());
          } else {
            return true;
          }
        });
      });

      //Ordenamiento
      if (this.campoOrden) {
        this.datosFiltrados = this.datosFiltrados.sort((a, b) => {
          if (this.ordenAsc) {
            return a[this.campoOrden] > b[this.campoOrden] ? 1 : -1;
          } else {
            return a[this.campoOrden] < b[this.campoOrden] ? 1 : -1;
          }
        });
      }

      //Paginacion
      this.totalPaginas = Math.ceil(this.datosFiltrados.length / this.tamano);
      this.selectedPage = page;
      this.paginaActual = page;
      this.isPage = !(
        this.selectedPage > this.totalPaginas || this.selectedPage <= 0
      );
      this.datosFiltrados = this.datosFiltrados.slice(
        (page - 1) * this.tamano,
        page * this.tamano
      );
    }
  }

  ordenar(field: string, asc: boolean) {
    this.campoOrden = field;
    this.ordenAsc = asc;
    this.filtrar(this.selectedPage);
  }

  getLinkParams(params: string[] | undefined, item: any) {
    if (!params || params.length == 0) return '';
    return params?.map(param => item[param]).join('/');
  }

  /**
   * Metodo para seleccionar la pagina
   * @param pageNumber numero de la pagina
   * @param index indice de la pagina
   */
  selectPage(pageNumber: number | string, index = -1) {
    if (pageNumber === '...') {
      if (index < 4) {
        pageNumber = this.paginaActual - 2;
      } else {
        pageNumber = this.paginaActual + 2;
      }
    }
    this.selectedPage = +pageNumber;
    this.filtrar(this.selectedPage);
    this.validatePage();
  }

  /**
   * Metodo para crear las paginas
   */
  pages() {
    const arr = [];
    if (this.totalPaginas <= 7) {
      for (let i = 0; i < this.totalPaginas; i++) {
        arr.push(i + 1);
      }
    } else {
      arr.push(1);
      if (this.paginaActual <= 4) {
        for (let i = 2; i <= 5; i++) {
          arr.push(i);
        }
        arr.push('...');
      } else if (this.paginaActual > this.totalPaginas - 4) {
        arr.push('...');
        for (let i = this.totalPaginas - 4; i < this.totalPaginas; i++) {
          arr.push(i);
        }
      } else {
        arr.push('...');
        for (let i = this.paginaActual - 1; i <= this.paginaActual + 1; i++) {
          arr.push(i);
        }
        arr.push('...');
      }
      arr.push(this.totalPaginas);
    }
    return arr;
  }

  /**
   * Metodo para validar la pagina
   */
  validatePage() {
    this.isPage = !(
      this.selectedPage > this.totalPaginas || this.selectedPage <= 0
    );
  }

  defaultAccion() {
  }

  accionCall(idAccion: string | undefined, item: any, i: number) {
    if (idAccion) {
      this.eventoAccion.emit({ idAccion: idAccion, item: item, index: i });
    } else {
      this.defaultAccion();
    }
  }

  columnasVisibles(): TableColumn[] {
    return this.columnas.filter(x => x.visible || x.visible == undefined);
  }

  cambiarVisibilidad(event: Event, i: number) {
    this.columnas[i].visible = (
      event.target as unknown as {
        checked: boolean;
      }
    ).checked;
  }

  getValor(column: TableColumn, item: any) {
    let valor = column.field.split('.').reduce((o, i) => o?.[i], item);

    // Si es array de objetos devuelve concatenado
    if (Array.isArray(valor)) {
      return valor.map(v => v.nombre ?? v).join(', ');
    }
    return valor;
  }

  toggleSelection(item: any) {
    if (this.selection.has(item[this.idColumn])) {
      this.selection.delete(item[this.idColumn]);
      this.selectedItems = this.selectedItems.filter(
        value => value[this.idColumn] !== item[this.idColumn]
      );
    } else {
      this.selection.add(item[this.idColumn]);
      this.selectedItems.push(item);
    }
    this.emitSelectedItems();
  }

  isAllSelected(): boolean {
    return this.selection.size === this.datos.length;
  }

  toggleAllSelection(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.datos.forEach(item => {
        this.selection.add(item[this.idColumn]);
        this.selectedItems.push(item);
      });
    } else {
      this.selection.clear();
      this.selectedItems = [];
    }
    this.emitSelectedItems();
  }

  getSelectedItems(): any[] {
    return this.selectedItems;
  }

  emitSelectedItems() {
    this.selectedItemsChange.emit(this.getSelectedItems());
  }

  isSelected(item: any): boolean {
    return this.selection.has(item[this.idColumn]);
  }

  clearSelection() {
    this.selectedItems = [];
    this.selectedItemsChange.emit([]);
  }
}
